module.exports = __webpack_public_path__ + "img/9788958073826.7ba313c9.jpg";